import { useEffect, useState } from 'react';
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
import { useApp } from '../store';
import API from '../api';

export default function BuyCard() {
  const { code } = useParams();
  const [searchParams] = useSearchParams();
  const { user } = useApp();
  const nav = useNavigate();

  const [sale,    setSale]    = useState(null);
  const [loading, setL]       = useState(true);
  const [buying,  setBuying]  = useState(false);
  const [err,     setErr]     = useState('');
  const paid = searchParams.get('paid') === '1';

  useEffect(() => { fetchSale(); }, []); // eslint-disable-line

  async function fetchSale() {
    setL(true);
    try {
      const r = await API.get(`/api/card-sale/${code}`, { skipAuth: true });
      setSale(r.sale);
    } catch(e) {
      setErr(e.message || '链接无效或已过期');
    } finally { setL(false); }
  }

  async function doBuy() {
    if (!user) { nav(`/?redirect=/buy/${code}`); return; }
    setBuying(true); setErr('');
    try {
      const r = await API.post(`/api/card-sale/${code}/buy`, {});
      if (r.payUrl) window.location.href = r.payUrl;
    } catch(e) { setErr(String(e?.message || e || '操作失败，请刷新重试')); }
    finally { setBuying(false); }
  }

  function timeLeft(expiresAt) {
    const diff = new Date(expiresAt) - new Date();
    if (diff <= 0) return '已过期';
    const h = Math.floor(diff / 3600000);
    const m = Math.floor((diff % 3600000) / 60000);
    return `${h}小时 ${m}分钟`;
  }

  const S = `
    *{box-sizing:border-box;margin:0;padding:0;}
    .bc-root{min-height:100vh;
      background:linear-gradient(180deg,#0B1E4A 0%,#0D2B6B 50%,#091840 100%);
      display:flex;align-items:center;justify-content:center;padding:20px;}
    .bc-card{width:100%;max-width:400px;background:#0F2554;border-radius:20px;padding:28px 24px;text-align:center;}
    .bc-logo{font-size:48px;margin-bottom:8px;}
    .bc-brand{font-size:20px;font-weight:900;color:#fff;margin-bottom:4px;}
    .bc-sub{font-size:12px;color:#8BA8D4;margin-bottom:28px;}
    .bc-box{background:rgba(46,127,232,0.08);border-radius:14px;padding:20px;margin-bottom:20px;}
    .bc-num{font-family:'Share Tech Mono',monospace;font-size:48px;font-weight:900;color:#F5C518;line-height:1;}
    .bc-unit{font-size:16px;color:#8BA8D4;margin-top:4px;margin-bottom:16px;}
    .bc-price{font-family:'Share Tech Mono',monospace;font-size:32px;font-weight:900;color:#fff;line-height:1;}
    .bc-price-unit{font-size:13px;color:#8BA8D4;margin-top:4px;}
    .bc-meta{display:flex;justify-content:space-between;font-size:12px;color:#8BA8D4;margin-top:16px;padding-top:14px;border-top:1px solid rgba(46,127,232,0.15);}
    .bc-timer{color:#F5C518;font-weight:700;}
    .btn-buy{width:100%;padding:16px;border-radius:14px;border:none;cursor:pointer;
      font-size:16px;font-weight:900;
      background:linear-gradient(180deg,#FFD700 0%,#E6A800 100%);color:#000;
      box-shadow:0 5px 0 #8B6200;}
    .btn-buy:active{transform:translateY(4px);box-shadow:0 1px 0 #8B6200;}
    .btn-buy:disabled{opacity:0.4;cursor:not-allowed;transform:none;box-shadow:none;}
    .bc-err{padding:10px 14px;border-radius:10px;font-size:13px;
      background:rgba(232,69,60,0.1);color:#E8453C;margin-bottom:14px;}
    .bc-ok{padding:14px;border-radius:12px;font-size:14px;font-weight:700;
      background:rgba(46,204,113,0.1);color:#2ECC71;margin-bottom:14px;}
  `;

  return (
    <div className="bc-root">
      <style>{S}</style>
      <div className="bc-card">
        
        <div className="bc-brand">SpaceX Battle</div>
        <div className="bc-sub">房卡交易</div>

        {loading && <div style={{color:'#8BA8D4',fontSize:14}}>加载中...</div>}

        {!loading && err && (
          <>
            <div className="bc-err">{err}</div>
            <button className="btn-buy" onClick={() => nav('/lobby')}>返回大厅</button>
          </>
        )}

        {!loading && sale && !paid && (
          <>
            <div className="bc-box">
              <div className="bc-num">{sale.cards_amount}</div>
              <div className="bc-unit">张房卡</div>
              <div style={{width:'100%',height:1,background:'rgba(46,127,232,0.2)',margin:'14px 0'}}/>
              <div className="bc-price">{parseFloat(sale.price_usdt).toFixed(2)}</div>
              <div className="bc-price-unit">USDT</div>
              <div className="bc-meta">
                <span>卖家：{sale.seller_nickname}</span>
                <span>剩余 <span className="bc-timer">{timeLeft(sale.expires_at)}</span></span>
              </div>
            </div>

            {err && <div className="bc-err">{err}</div>}

            <div style={{fontSize:12,color:'#8BA8D4',marginBottom:16,lineHeight:1.7}}>
              付款后房卡自动到账 · 通过 PayTheFly 安全支付
            </div>

            <button className="btn-buy" onClick={doBuy} disabled={buying}>
              {buying ? '跳转付款中...' : `立即购买 ${parseFloat(sale.price_usdt).toFixed(2)} USDT`}
            </button>

            {!user && (
              <div style={{fontSize:12,color:'#8BA8D4',marginTop:12}}>
                购买需要登录账号
              </div>
            )}
          </>
        )}

        {paid && (
          <>
            <div style={{fontSize:48,fontWeight:900,color:'#F5C518',margin:'8px 0 4px'}}>
              {sale ? sale.cards_amount : ''}
            </div>
            {sale && <div style={{fontSize:16,color:'#8BA8D4',marginBottom:20}}>张房卡</div>}
            <div className="bc-ok">
              购买成功！房卡将在链上确认后自动到账，请稍候。
            </div>
            <button className="btn-buy" onClick={() => nav('/lobby')}>返回大厅</button>
          </>
        )}
      </div>
    </div>
  );
}
